import axios from 'axios';

import { getTradesApiPathv3 } from './helpers';

export type FeatureFlag = {
  featureFlagName: string;
  id: number;
  isActive: boolean;
};

type FeatureFlagsResponse = {
  content: FeatureFlag[];
  errorMessage: string;
  status: string;
};

class FeaturesApi {
  getFeatures = (signal?: AbortSignal) => {
    const uri = getTradesApiPathv3('features', '');
    return axios.get<FeatureFlagsResponse>(uri, { signal, timeout: 1500 });
  };
}

export default FeaturesApi;
